export default "__VITE_ASSET__BlDRlUhY__"